export default __webpack_public_path__ + "static/wallpaper-351dbd721de5bd89c739508d154015e5.jpg";